// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface SplitPage {
    pageNumber: number;
    data: Uint8Array;
    split?: boolean;
}

@Component({
    selector: 'app-split-pdf-modal',
    templateUrl: './split-pdf-modal.component.html',
    styleUrls: ['./split-pdf-modal.component.scss'],
})
export class SplitPdfModalComponent implements OnInit {
    public pages: SplitPage[];

    constructor(
        private dialogRef: MatDialogRef<SplitPdfModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.pages = this.data?.pages;
    }

    toggleSplit(page: SplitPage) {
        page.split = !page.split;
    }

    splitAll() {
        // Mark all splist as true
        for (const [index, page] of this.pages.entries()) {
            if (index + 1 < this.pages.length) {
                page.split = true;
            }
        }

        this.confirmSplit();
    }

    confirmSplit() {
        // Split the pages into an array of arrays which
        // will be used by PDFTron to perform the splits
        const splits: number[][] = [];
        let currentSplit = [];
        for (const [index, page] of this.pages.entries()) {
            currentSplit.push(index + 1);
            if (page.split) {
                splits.push(currentSplit);
                currentSplit = [];
            } else if (index + 1 === this.pages.length) {
                splits.push(currentSplit);
            }
        }

        this.dialogRef.close({ splits });
    }

    close(): void {
        this.dialogRef.close();
    }
}
